module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-12-0f43b62185678de50a8226991eb66145.jpg";